import { useState } from "react";
import { Button } from "react-bootstrap";
import "../styles/navbar.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import pic from "../assets/blue.png";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useEffect } from "react";
import axios from "axios";
import { Link, NavLink } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { MDBBadge, MDBIcon } from "mdb-react-ui-kit";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { passwordValidator } from "../helpers/passwordValidator";
import { useSnackbar } from "../contexts/SnackbarContext";

export default function Navbar() {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const logOutClickHandler = (e) => {
    e.preventDefault();
    localStorage.removeItem("dtt_PatientToken");
    localStorage.removeItem("dtt_PatientId");
    navigate("/Login");
  };
  const [modalVisiblePassword, setModalVisiblePassword] = useState(false);
  const [passwordSet, setPasswordSet] = useState({ value: "", error: "" });
  const [password, setPassword] = useState({ value: "", error: "" });
  const [confirmPassword, setConfirmPassword] = useState({
    value: "",
    error: "",
  });
  const [dashboardValues, setDashboardValues] = useState([]);
  const [data, setData] = useState([]);
  const [image, setImage] = useState("");

  const [CIDI, setCIDI] = useState(false);
  const [AUDIT, setAUDIT] = useState(false);
  const [CRAFFT, setCRAFFT] = useState(false);
  const [DAST, setDAST] = useState(false);
  const [MDQ, setMDQ] = useState(false);
  const [PTSD, setPTSD] = useState(false);
  const [YBCS, setYBCS] = useState(false);
///Change Password
const handleClosePassword = () => {
  setModalVisiblePassword(false);
  navigate("/Home");
};
const keyUpsetP = (e) => {
  if (e.key === "Enter") {
    onLoginPressedSet();
  }
};
const axiosConfig = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};
const onLoginPressedSet = () => {
  const passwordError = passwordValidator(passwordSet.value);
  if (passwordError) {
    setPasswordSet({ ...passwordSet, error: passwordError });
    return;
  }
  if (passwordSet.value != confirmPassword.value) {
    showSnackbar('Password Do not Match', 'error');
    return;
  }

  const passwordEmail = localStorage.getItem("patientuserEmail");

  const postData = {
    emailAddress: passwordEmail,
    password: passwordSet.value,
    isActive: true,
    pin: "",
    isPINActive: true,
    practiceId: 0,
    createdDate: "",
    updatedDate: "",
    token: "",
  };

  console.log("PostData: ", postData.emailAddress);
  axios
    .post(
      `${process.env.REACT_APP_API_URL}/PatientPortal/setPassword`,
      postData,
      axiosConfig
    )
    .then((response) => {
      console.log("Password set response:", response.data);
      if (response.data && response.data.id) {
        // Close modal
        setModalVisiblePassword(false);
        // Clear password fields
        setPasswordSet({ value: "", error: "" });
        setConfirmPassword({ value: "", error: "" });
        // Show success message
        showSnackbar('Password changed successfully!', 'success');
        // Navigate to Home
        navigate("/Home");
      } else {
        showSnackbar('Oops! Something went wrong. Please try again.', 'error');
      }
    })
    .catch((error) => {
      console.error("Error setting password:", error);
      showSnackbar('Error setting password: ' + error.message, 'error');
    });
};
  useEffect(() => {
    const patId = localStorage.getItem("dtt_PatientId");
    const token = localStorage.getItem("dtt_PatientToken");

    if (!patId || !token) return;

    // Fetch patient details
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientPortal/getPatientDetailsById?pateintid=${parseInt(patId)}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setDashboardValues(response.data);
        setImage(response.data.photoUrl);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });

    // Fetch patient to-do list
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientToDoList/getpatientToDoListById?patientid=${parseInt(patId)}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        // Filter only items where isChecked is true
        const checkedItems = response.data.filter(item => item.isChecked === true);

        // Remove duplicates based on toDoItemsId - keep only unique items
        const uniqueItems = checkedItems.reduce((acc, current) => {
          const exists = acc.find(item => item.toDoItemsId === current.toDoItemsId);
          if (!exists) {
            acc.push(current);
          }
          return acc;
        }, []);

        setData(uniqueItems);

        uniqueItems.forEach((element) => {
          console.log("ItemId.......................", element.toDoItemsId);
          if (element.toDoItemsId === 1) setCIDI(true);
          if (element.toDoItemsId == 2) setAUDIT(true);
          if (element.toDoItemsId === 3) setCRAFFT(true);
          if (element.toDoItemsId === 4) setDAST(true);
          if (element.toDoItemsId === 5) setMDQ(true);
          if (element.toDoItemsId === 6) setPTSD(true);
          if (element.toDoItemsId === 7) setYBCS(true);
        });
      })
      .catch((error) => {
        console.error("There was an error in patient todo", error);
      });
  }, []);

  return (
    <>
    <Modal show={modalVisiblePassword} onHide={handleClosePassword} style={{marginTop:'100px'}}>
        <Modal.Header closeButton>
          <Modal.Title>Please Set your Password.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row style={{ margin: "10px" }}>
            <Col>
              <label style={{ width: "40%", float: "center" }}>New Password:</label>
              <input
                style={{
                  backgroundColor: "#73C2E3",
                  border: "2px solid #fcbe13",
                  borderRadius: "10px",
                  height: "45px",
                  margin: "10px",
                  float: "center",
                }}
                returnKeyType="done"
                value={passwordSet.value}
                //  onKeyUp={keyUp}
                // value={email.value}
                onChange={(text) => {
                  // console.log("Test: ", text.target.value);
                  setPasswordSet({ value: text.target.value, error: "" });
                }}
                error={!!password.error}
                errorText={password.error}
                secureTextEntry
              />
            </Col>
          </Row>
          <Row style={{ margin: "10px" }}>
            <Col>
              <label style={{ width: "40%", float: "center" }}>
                Confirm Password:
              </label>

              <input
                style={{
                  backgroundColor: "#73C2E3",
                  border: "2px solid #fcbe13",
                  borderRadius: "10px",
                  height: "45px",
                  margin: "10px",
                  float: "center",
                }}
                returnKeyType="done"
                value={confirmPassword.value}
                onKeyUp={keyUpsetP}
                onChange={(text) =>
                  setConfirmPassword({ value: text.target.value, error: "" })
                }
                secureTextEntry
              />
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <Button mode="contained" onClick={onLoginPressedSet}>
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    <nav className="navigation sticky-nav" bg="dark" variant="dark" style={{ zIndex: "1" }} >
      <img
        onClick={() => navigate("/Home")}
        src={logo}
        width="150px"
        height="65px"
        style={{ marginLeft: "2px", cursor: "pointer" }}
      />
      <div>
        <button
          className="hamburger"
          onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}
        >
          {/* icon from Heroicons.com */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
      <div
        className={
          isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
        }
      >
        <ul>
          <li>
            <NavLink to="/Home">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/PHQ">
              PHQ9
            </NavLink>
          </li>
          <li>
            <NavLink to="/GAD">GAD7</NavLink>
          </li>
          <li>
            <NavLink to="/Journal">Journal</NavLink>
          </li>
          <li>
            <NavLink to="/LearningDocuments">Learn</NavLink>
          </li>
          <li>
            <NavLink to="/Meditate">Meditate</NavLink>
          </li>
          <li>
            <NavLink to="/CareTeam">Care Team</NavLink>
          </li>
          <li>
            <NavLink to="/Videos">Videos</NavLink>
          </li>
          <li>
            <NavLink to="/Appointment">Appointment</NavLink>
          </li>
          <li style={{ marginLeft: "30px" }}>
            <Dropdown>
              <Dropdown.Toggle
                id="dropdown-basic"
                style={{
                  marginTop: 13,
                  backgroundColor: "#FCBE13",
                  borderRadius: 80,
                }}
              >
                To Do
                <MDBBadge style={{ margin: 2 }} color="danger" notification pill>
                  {data.length}
                </MDBBadge>
              </Dropdown.Toggle>

            {data.length > 0 ? (
              <Dropdown.Menu style={{ textAlign: "center", zIndex: 9999, position: "absolute" }}>
                {CIDI ? (
                  <>
                  <Dropdown.Item href="/CidiBased">
                    {/* <Link to="/CidiBased">CidiBased</Link> */}
                    CidiBased
                  </Dropdown.Item>
                <div class="dropdown-divider"></div>
                </>
                ) : null}

                {AUDIT ? (
                  <>
                  <Dropdown.Item href="/Audit">
                    {/* <Link to="/CidiBased">CidiBased</Link> */}
                    Audit-C
                  </Dropdown.Item>
                    <div class="dropdown-divider"></div>
                    </>
                ) : null}

                {CRAFFT ? (
                  <>
                  <Dropdown.Item href="/Crafft">Crafft</Dropdown.Item>
                <div class="dropdown-divider"></div></>
                ) : null}

                {DAST ? (
                  <>
                  <Dropdown.Item href="/Dast">
                    {/* <Link to="/CidiBased">CidiBased</Link> */}
                    Dast
                  </Dropdown.Item>
                  <div class="dropdown-divider"></div>
                  </>
                ) : null}

                {MDQ ? (<>
                  <Dropdown.Item href="/Mdq">
                    {/* <Link to="/CidiBased">CidiBased</Link> */}
                    MDQ
                  </Dropdown.Item>
                <div class="dropdown-divider"></div>
                </>
                ) : null}
                {PTSD ? (
                  <>
                  <Dropdown.Item href="/Ptsd">
                    {/* <Link to="/CidiBased">CidiBased</Link> */}
                    PTSD
                  </Dropdown.Item>
                <div class="dropdown-divider"></div>
                </>
                ) : null}
                {YBCS ? (
                  <Dropdown.Item href="/Ybocs">
                    {/* <Link to="/CidiBased">CidiBased</Link> */}
                    YBCS
                  </Dropdown.Item>
                ) : null}
                {/* </NavDropdown> */}
              </Dropdown.Menu>
            ) : (
              <Dropdown.Menu style={{ zIndex: 9999, position: "absolute" }}>
                <Dropdown.Item>
                  Questionnaire is not assigned yet!
                </Dropdown.Item>
              </Dropdown.Menu>
            )}
            </Dropdown>
          </li>
        </ul>
      </div>
      <div className="navigation-pic">
  <NavDropdown
    title={
      <>
        {dashboardValues.lastName != null || dashboardValues.lastName != undefined ? (
          <label
            className="patientname"
            style={{
              color: "black",
              fontSize: 18,
              fontWeight: "bold",
              marginBottom: 5,
            }}
          >
            {`${dashboardValues.lastName}, ${dashboardValues.firstName}`}
          </label>
        ) : (
          // <label>Loading! Please Wait.</label>
          ''
        )}
        {image && image.length > 0 ? (
          <img
            className="imgPatient"
            style={{
              marginTop: "5px",
              width: "60px",
              height: "60px",
              margin: "5px",
              borderRadius: "100px",
              objectFit: "stretch",
            }}
            height="55 px"
            src={`${process.env.REACT_APP_Documents_URL}/${image}`}
          ></img>
        ) : (
          <img
            className="imgPatient"
            style={{
              marginTop: "5px",
              width: "60px",
              height: "60px",
              margin: "5px",
              borderRadius: "100px",
              objectFit: "stretch",
            }}
            height="55 px"
            src={pic}
          ></img>
        )}
      </>
    }
    id="basic-nav-dropdown"
  >
    <NavDropdown.Item onClick={() => {
      setModalVisiblePassword(true);
    }}>
      Change Password
    </NavDropdown.Item>
    <NavDropdown.Item onClick={logOutClickHandler}>
      Logout
    </NavDropdown.Item>
  </NavDropdown>
</div>

    </nav> 
    </>
  );
}
